/**
 * Project : workspace
 * File    : BusinessNavGraph.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation.graph.business

import androidx.navigation.NavGraph
import androidx.navigation.compose.composable
import androidx.navigation.createGraph
import com.parmartechnologies.communication.ui.conversation.detail.ConversationDetailsScreen
import navigation.AppNavigator
import navigation.base.FriendlyWindow
import navigation.route.business.BusinessNavRoute
import presentation.screens.business.home.NewBusinessHomeScreen
import presentation.screens.business.homepage.BusinessHomePageScreen
import presentation.screens.business.onboard.create_business_screen.CreateBusinessScreen
import presentation.screens.business.onboard.select_business_type.CreateBusinessType
import presentation.screens.business.onboard.select_business_type.SelectBusinessTypeScreen
import presentation.screens.business.relation.RelationHomeScreen
import presentation.screens.business.self_business.list.SelfBusinessListScreen
import presentation.screens.business.self_business.select.SelfBusinessSelectScreen
import presentation.screens.chat.conversation.list.ConversationListScreens
import presentation.screens.common.account.AccountScreen
import presentation.screens.common.notification.BusinessNotificationScreen

/**
 * Represents the business nav graph class.
 */

class BusinessNavGraph {
    fun navGraph(start: String = BusinessNavRoute.HOME): NavGraph {
        val graph =
            FriendlyWindow.Companion.navigationController?.createGraph(startDestination = BusinessNavRoute.HOME) {
                composable(route = BusinessNavRoute.LANDING) {
                    BusinessHomePageScreen().Content()
                }
                composable(route = BusinessNavRoute.HOME) {
                    NewBusinessHomeScreen().Content()
                }
                composable(route = BusinessNavRoute.CONVERSATION) {
                    ConversationListScreens().Content()
                }
                composable(route = BusinessNavRoute.CHAT) {
                    ConversationDetailsScreen(AppNavigator.shared().getNavigationParam().conversation)
                }
                composable(route = BusinessNavRoute.ACCOUNT) {
                    AccountScreen().Content()
                }
                composable(route = BusinessNavRoute.NOTIFICATION) {
                    BusinessNotificationScreen().Content()
                }
                composable(route = BusinessNavRoute.Companion.RELATION) {
                    RelationHomeScreen().content()
                }
            }
        return graph!!
    }
    /**
 * Executes the onboarding operation.
 *
 * @receiver TODO
 * @return The resulting nav graph.
 */
    fun onboarding(): NavGraph {
        val graph =
            FriendlyWindow.Companion.navigationController?.createGraph(startDestination = BusinessNavRoute.Companion.LIST) {
                composable(route = BusinessNavRoute.Companion.LIST) {
                    SelfBusinessListScreen().Content()
                }

                composable(route = BusinessNavRoute.Companion.CREATE) {
                    CreateBusinessScreen().Content()
                }
                composable(route = BusinessNavRoute.Companion.BUSINESS_TYPE) {
                    SelectBusinessTypeScreen().Content()
                }
                composable(route = BusinessNavRoute.Companion.BUSINESS_TYPE_CREATE) {
                    CreateBusinessType().Content()
                }
                composable(route = BusinessNavRoute.Companion.SELECT_SELF_BUSINESS) {
                    SelfBusinessSelectScreen().Content()
                }
            }
        return  graph!!
    }

}